import { defineStore } from 'pinia';
import { useState } from '@/composables/common/useState';
import i18n from '@/i18n';
import vuetify from '@/plugins/vuetify';

export const useLocalizationStore = defineStore('Localizations', () => {
  const [currentLocale, setCurrentLocale] = useState<string>(i18n.locale);

  const refreshLocale = () => {
    changeLanguage(currentLocale.value);
  };

  const changeLanguage = (newLocale: string) => {
    setCurrentLocale(newLocale);
    i18n.locale = newLocale;
    vuetify.framework.lang.current = newLocale;
  };

  return { currentLocale, refreshLocale, changeLanguage };
});
